import React, {Fragment, useContext, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Box, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {MenuContext} from "../../contexts/menuContext";
import SettingSidebar from "./settingSidebar/settingSidebar";
import MyAccount from "./myAccount/myAccount";
import Profile from "./profile/profile";
import PrivacySafety from "./privacySafety/privacySafety";
import ReferralPayouts from "./referralPayouts/referralPayouts";
import ReferralLinks from "./referralLinks/referralLinks";
import PromoMaterial from "./promoMaterial/promoMaterial";
import Notifications from "./notifications/notifications";
import MySubscriptions from "./mySubscriptions/mySubscriptions";
import Billing from "./billing/billing";
import PremiumPlans from "./premiumPlans/premiumPlans";
import SendGift from "./sendGift/sendGift";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";

import premium from "../../assets/images/premium.svg";
import menuIcon from "../../assets/images/menuIcon.svg";
import "./settings.css";
import {BackSetitngButton} from "../../components/BackSettinButton";

const settingMenu = [
  {href: "/settings", content: <MyAccount />},
  {href: "/settings/myaccount", content: <MyAccount />},
  {href: "/settings/profile", content: <Profile />},
  {href: "/settings/privacy-safety", content: <PrivacySafety />},
  {href: "/settings/payouts", content: <ReferralPayouts />},
  {href: "/settings/referral-links", content: <ReferralLinks />},
  // { href: "/settings/promo-material", content: <PromoMaterial /> },
  {href: "/settings/notifications", content: <Notifications />},
  {href: "/settings/subscriptions", content: <MySubscriptions />},
  {href: "/settings/billing", content: <Billing />},
  // { href: "/settings/premium-plans", content: <PremiumPlans /> },
  // { href: "/settings/send-gift", content: <SendGift /> },
];

const Settings = () => {
  const {open, setOpen, isSmall} = useContext(MenuContext);
  const location = useLocation();
  const [currentRoute] = useState(location?.pathname ?? "/");
  const isSettings = currentRoute === "/settings" || currentRoute === "/settings/";
  const navigate = useNavigate();

  return (
    <Box
      className={open ? "showSettingMenu settingMain" : "settingMain"}
      sx={{
        display: "flex",
        justifyContent: "center",
        overflowY: "overlay",
      }}
    >
      {((isSmall && isSettings) || !isSmall) && <SettingSidebar />}
      {(!isSmall || !isSettings) && (
        <Box className="settingContent" maxWidth="850px">
          {isSmall && <BackSetitngButton label={"Setting Overview"} />}
          {settingMenu.map((route, key) => (
            <Fragment key={key}>{currentRoute === route.href && route.content}</Fragment>
          ))}
        </Box>
      )}
      {!isSmall && (
        <HighlightOffRoundedIcon
          sx={{
            position: "sticky",
            color: "rgba(255, 255, 255, 0.6)",
            height: "30px",
            width: "30px",
            cursor: "pointer",
            top: "54px",
          }}
          onClick={() => navigate("/dashboard")}
        />
      )}
    </Box>
  );
};

export default Settings;
